// w12.js
import React from 'react';
import WW from './ww';
import { pageConfigs } from '../../configs';

const W12 = () => {
  return <WW config={pageConfigs.w12} />;
};

export default W12;
